export default 'M12 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m1.5 7.5a1.5 1.5 0 1 1-3 0v-5a1.5 1.5 0 1 1 3 0zM12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24';